import api from './api';
import { NotificationItem, NotificationReadStatus, NotificationRecipientRole } from '@/types/notification';

type GetNotificationsOptions = {
    status?: NotificationReadStatus;
    recipientRole?: NotificationRecipientRole | 'all';
    limit?: number;
    scope: 'admin' | 'vendor';
};

export const notificationApi = {
    async getNotifications(options: GetNotificationsOptions): Promise<NotificationItem[]> {
        try {
            const { scope, status = 'all', recipientRole = 'all', limit = 50 } = options;
            const endpoint = scope === 'admin' ? '/admin/notifications' : '/vendor/notifications';
            const response = await api.get(endpoint, {
                params: {
                    status,
                    limit,
                    ...(scope === 'admin' && recipientRole !== 'all' ? { recipientRole } : {}),
                },
            });

            return response.data.notifications || [];
        } catch (error: any) {
            console.error('Error fetching notifications:', error);
            throw new Error(error.response?.data?.error || 'Bildirimler yüklenemedi');
        }
    },

    async getUnreadCount(scope: 'admin' | 'vendor', recipientRole?: NotificationRecipientRole | 'all'): Promise<number> {
        try {
            const endpoint = scope === 'admin' ? '/admin/notifications/summary' : '/vendor/notifications/summary';
            const response = await api.get(endpoint, {
                params: {
                    ...(scope === 'admin' && recipientRole && recipientRole !== 'all' ? { recipientRole } : {}),
                },
            });

            return response.data.unreadCount || 0;
        } catch (error: any) {
            console.error('Error fetching notification summary:', error);
            throw new Error(error.response?.data?.error || 'Bildirim özeti yüklenemedi');
        }
    },

    async markAsRead(scope: 'admin' | 'vendor', notificationId: string): Promise<NotificationItem> {
        try {
            const endpoint = scope === 'admin'
                ? `/admin/notifications/${notificationId}/read`
                : `/vendor/notifications/${notificationId}/read`;
            const response = await api.patch(endpoint);
            return response.data.notification;
        } catch (error: any) {
            console.error('Error marking notification as read:', error);
            throw new Error(error.response?.data?.error || 'Bildirim güncellenemedi');
        }
    },

    async markAllAsRead(scope: 'admin' | 'vendor', recipientRole?: NotificationRecipientRole | 'all'): Promise<number> {
        try {
            const endpoint = scope === 'admin' ? '/admin/notifications/read-all' : '/vendor/notifications/read-all';
            const response = await api.patch(endpoint, scope === 'admin' && recipientRole && recipientRole !== 'all'
                ? { recipientRole }
                : undefined);
            return response.data.updatedCount || 0;
        } catch (error: any) {
            console.error('Error marking all notifications as read:', error);
            throw new Error(error.response?.data?.error || 'Bildirimler güncellenemedi');
        }
    },

    async sendBroadcastPush(data: { title: string; body: string; targetRole?: string }): Promise<any> {
        try {
            const response = await api.post('/admin/notifications/push/broadcast', data);
            return response.data;
        } catch (error: any) {
            console.error('Error sending broadcast push:', error);
            throw new Error(error.response?.data?.error || 'Toplu bildirim gönderilemedi');
        }
    },

    async sendUserPush(userId: string, data: { title: string; body: string; userType?: string }): Promise<any> {
        try {
            const response = await api.post(`/admin/notifications/push/user/${userId}`, data);
            return response.data;
        } catch (error: any) {
            console.error('Error sending user push:', error);
            throw new Error(error.response?.data?.error || 'Kullanıcıya bildirim gönderilemedi');
        }
    },
};